import { abilityEntryId } from '../ability/charges/charge-entry.js';
import { record, type Row } from '../ability/context.js';
import { statusItemId } from '../statuses/expiry.js';
import { TRIGGER_CARRIERS, heldStatusDefinition, type TriggerReaders } from './trigger-dispatch.js';
import { fullDefinition } from './php-row-rules.js';
import { contingencySpellIds } from '../sanguine/contingency-inputs.js';

/** The turn and ability lanes warm the same delivered carrier/status inventory.
 * Discovery only collects inputs; it never guesses whether an unknown carrier fires. */
export function collectTriggerDefinitionInputs(roster: readonly Row[], read: TriggerReaders, statuses: (member: Row) => Row[]): {
  missing: string[]; definitions: Row[];
} {
  const missing = new Set<string>(), definitions = new Set<Row>();
  const add = (id: string, definition: Row | null): void => {
    if (definition) definitions.add(definition);
    else if (/^[0-9A-F]{8}(-[0-9A-F]{4}){3}-[0-9A-F]{12}$/i.test(id)) missing.add(id);
  };
  for (const member of roster) {
    for (const carrier of TRIGGER_CARRIERS) {
      const entries = [...read.entries(member, carrier), ...(Array.isArray(member[carrier]) ? member[carrier] as unknown[] : [])];
      for (const raw of entries) {
        const entry = record(raw), source = record(entry?.item_arr ?? raw), id = abilityEntryId(raw);
        const inline = source && record(source.item_layer_types) && Object.keys(source.item_layer_types as Row).length ? source : null;
        add(id, inline ?? fullDefinition(read.definition(id, 'any'), 'any'));
      }
    }
    const held = statuses(member);
    for (const status of held) add(statusItemId(status), heldStatusDefinition(read, status, member));
    for (const id of contingencySpellIds(held)) add(id, fullDefinition(read.definition(id, 'any'), 'any'));
  }
  return { missing: [...missing], definitions: [...definitions] };
}
